import CareerInfo from "../../Components/Organisms/Careers/CareerInfo";
import HeroSection from "../../Components/Organisms/Careers/HeroSection";
import OpprtunitySection from "../../Components/Organisms/Careers/OpportunitySection";
import ShareVision from "../../Components/Organisms/Careers/ShareVision";

const CareersPage = () => {
    return (
        <div>
            <HeroSection />
            <CareerInfo />
            <OpprtunitySection />
            <ShareVision id="shareVisionSection" />
        </div>
    );
};

export default CareersPage